import { render } from "./waivers.vue?vue&type=template&id=408e4e08&ts=true"
import script from "./waivers.vue?vue&type=script&lang=ts"
export * from "./waivers.vue?vue&type=script&lang=ts"

import "./waivers.vue?vue&type=style&index=0&id=408e4e08&lang=scss"

import exportComponent from "/agent/_work/1/s/Customer/onlinekiosk_vue_js/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__